export default __webpack_public_path__ + "static/media/may-2017.9684e26f.csv";